import layout from './Layout.container';

export default layout;
